// extracted by mini-css-extract-plugin
export var articleEybrowText = "Articles-module--article-eybrow-text--2ddb7";
export var articleHeader = "Articles-module--article-header--efb22";
export var articleHeaderSection = "Articles-module--article-header-section--d2d54";
export var articlePage = "Articles-module--article-page--a237e";
export var contentWrap = "Articles-module--content-wrap--c54c6";
export var innerContentWrapper = "Articles-module--inner-content-wrapper--a573e";
export var loginWrapper = "Articles-module--login-wrapper--db37a";
export var summarySection = "Articles-module--summary-section--d7a68";
export var tableOfContents = "Articles-module--table-of-contents--829a2";
export var tableOfContentsHeader = "Articles-module--table-of-contents-header--34381";